import { not, rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const midRules = composition => {
  const { variantIs, planIs, planIsAtLeast, hasProduct, stateIsMaximized, positionLocationHIs } = composition.checkers;

  return [
    rule('mid')
      .when(variantIs('mid'))
      .set(() => ({
        aspect: {
          fixedType: 'mid',
        },
        parts: {
          carousel: {
            location: 'contents',
            size: 'lg'
          },
          accordion: {
            useOverlay: true
          },
          dateBanner: {
            size: 'lg'
          },
          button: {
            size: 'lg'
          }
        }
      })),

    rule('mid/expanded')
      .when(variantIs('mid').and(stateIsMaximized))
      .set(() => ({
        container: {
          type: 'round-rectangle-concealed-top-left',
        },
        parts: {
          aubySeal: {
            offsetType: 'md',
            offsetBottom: false
          },
          headerText: {
            type: 'full',
            center: false,
          },
          menu: {
            includeMinimize: true,
          }
        },
      })),

    rule('mid/collapsed')
      .when(variantIs('mid').and(not(stateIsMaximized)))
      .set(() => ({
        parts: {
          aubySeal: {
            offsetType: 'xs',
            offsetBottom: true
          },
          headerText: {
            type: 'minimal',
            center: true,
          }
        },
      })),

    rule('mid/start+')
      .when(variantIs('mid').and(planIsAtLeast('start')))
      .set(() => ({
        parts: {
          accordion: {
            show: true
          }
        }
      })),

    rule('mid/free')
      .when(variantIs('mid').and(planIs('free')))
      .set(() => ({
        parts: {
          carousel: {
            includeBottomText: true
          }
        }
      })),

    rule('mid/expanded/free/right')
      .when(variantIs('mid').and(not(stateIsMaximized).and(planIs('free'))).and(positionLocationHIs('left')))
      .set(() => ({
        container: {
          type: 'pill-right',
        },
      })),

    rule('mid/expanded/free/left')
      .when(variantIs('mid').and(not(stateIsMaximized).and(planIs('free'))).and(positionLocationHIs('right')))
      .set(() => ({
        container: {
          type: 'pill-left',
        },
      })),

    rule('mid/expanded/start+')
      .when(variantIs('mid').and(not(stateIsMaximized)).and(not(planIs('free'))))
      .set(() => ({
        container: {
          type: 'round-rectangle-left',
        },
      })),

    rule('mid/premium')
      .when(variantIs('mid').and(planIs('premium')).and(hasProduct))
      .set(() => ({
        parts: {
          headerText: {
            type: "minimal",
            minimalOption: "only-authby",
            center: true
          },
          carousel: {
            location: null
          },
          headerImage: {
            show: true
          }
        }
      })),
  ];
};
